import { IdAndNameCell } from '@plato/ui-legacy/components/list-views/id-and-name-cell';
import { useParams } from 'react-router-dom';
import { useDialogs } from '../../dialogs/all-dialogs.tsx';

type Props = {
    erpProductId: string | null | undefined;
    productName: string | null | undefined;
    onClick?: () => void;
    className?: string;
    topClassName?: string;
    bottomClassName?: string;
};

export function ProductLinkCell({
    erpProductId,
    productName,
    onClick,
    className,
    bottomClassName,
    topClassName,
}: Props) {
    const { openProductDetails } = useDialogs();
    const params = useParams<{ customer_id: string }>();

    return (
        <IdAndNameCell
            to={`/inventory/${encodeURIComponent(erpProductId ?? '')}`}
            id={erpProductId}
            title={productName ?? ''}
            onClick={() => {
                if (erpProductId) {
                    onClick?.();
                    openProductDetails(erpProductId, params.customer_id || '');
                }
            }}
            className={className}
            bottomClassName={bottomClassName}
            topClassName={topClassName}
        />
    );
}
